import Card from "./Card.vue";
import Pagination from "./Pagination.vue";
import SidebarPlugin from "./SidebarPlugin";

let components = {
  Pagination,
  Card,
  SidebarPlugin,
};
export { Pagination, Card, SidebarPlugin };

export default components;
